export * from './main'
export * from './patients/patients'
export * from './consultations/consultations'
export * from './planning/planning'
export * from './planning-online/planning'
export * from './accounting/accounting'
export * from './reference/reference'
export * from './colleagues/colleagues'
export * from './colleagues/colleague/colleague'
export * from './top10/top10'